// Module
var code = "<h1 id=\"release-notes-10\">Release notes 1.0</h1> <p>Mise en production initiale du Backoffice</p> ";
// Exports
export default code;